<template>
  <div class="delete-video-tool">
    <div class="tool-main">
      <!-- 左侧：账户id + 素材id 输入 -->
      <div class="tool-left tool-left-double">
        <div class="left-col">
          <div class="left-title">
            账户ID（一行一个）
            <span v-if="accountList.length > 0" class="left-count">共 {{ accountList.length }} 个</span>
          </div>
          <el-input v-model="accountText" type="textarea" :rows="12" placeholder="请输入账户id，一行一个" clearable />
          <div class="left-tip">
            查询素材默认使用第一个账户：
            <b v-if="queryAdvertiserId">{{ queryAdvertiserId }}</b>
            <span v-else class="empty-tip">暂无，请先输入</span>
          </div>
        </div>
        <div class="left-col">
          <div class="left-title">
            素材ID（一行一个）
            <span v-if="materialIdList.length > 0" class="left-count">共 {{ materialIdList.length }} 个</span>
          </div>
          <el-input v-model="materialText" type="textarea" :rows="12" placeholder="请输入素材id，一行一个" clearable />
          <div class="left-tip">素材id可不填</div>
        </div>
        <!-- <el-button type="primary" size="small" style="margin-top: 8px; width: 100%" @click="searchClick">
          查询素材
        </el-button> -->
      </div>

      <!-- 右侧：素材选择（借鉴 ylySucaiSelector） -->
      <div class="tool-right">
        <div class="sucai-search-bar">
          <span class="sucai-label">素材名称</span>
          <el-input v-model="query.materialName" placeholder="输入后自动过滤本页" clearable style="width: 200px" />
          <span class="sucai-label">时长(秒)(本页过滤)</span>
          <el-input v-model="query.minDuration" placeholder="最小" size="small" clearable class="sucai-duration-input" />
          <span class="sucai-range-sep">-</span>
          <el-input v-model="query.maxDuration" placeholder="最大" size="small" clearable class="sucai-duration-input" />
          <el-button type="warning" size="small" :loading="verifying" @click="searchClick">查询</el-button>
          <el-button size="small" @click="selectAll">{{ isAllSelected ? '取消全选' : '全选' }}</el-button>
          <el-button v-if="selectedIds.length > 0" size="small" type="danger" plain @click="clearSelected">
            取消选中素材
          </el-button>
          <span v-if="selectedIds.length > 0" class="sucai-selected-count">
            已选 {{ selectedIds.length }} 个
          </span>
        </div>

        <div v-if="!hasSearched" class="right-empty-tip">请先在左侧输入账户id后点击查询</div>
        <div v-else v-loading="loading">
          <el-empty v-if="filteredList.length === 0" description="暂无素材" />
          <div v-else class="sucai-grid">
            <div v-for="item in filteredList" :key="getItemId(item)" class="sucai-grid-item"
              :class="{ active: selectedIds.includes(getItemId(item)) }" @click="toggleSelect(item)">
              <div class="sucai-cover">
                <img :src="item.poster_url" />
                <div v-show="selectedIds.includes(getItemId(item))" class="sucai-mask"></div>
                <span v-show="selectedIds.includes(getItemId(item))" class="sucai-check">✓</span>
              </div>
              <div class="sucai-meta">
                <div class="sucai-name" :title="item.material_name || item.filename || item.file_name">
                  {{ item.material_name || item.filename || item.file_name }}
                </div>
                <div v-if="item.duration !== undefined && item.duration !== null && item.duration !== ''"
                  class="sucai-duration">
                  时长 {{ Number(item.duration).toFixed(0) }}s
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="pagination sucai-pagination">
          <pagination :total="total" :pagesize="query.pageSize" :currentPage="query.page"
            @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></pagination>
        </div>
      </div>
    </div>

    <div class="tool-footer">
      <div class="footer-left">
        <el-button type="danger" plain :loading="directDeleting" :disabled="directCooldown > 0" @click="directDelete">
          {{ directCooldown > 0 ? `通过素材id删除(${directCooldown}s)` : '通过素材id删除' }}
        </el-button>
      </div>
      <div class="footer-right">
        <el-button @click="$emit('cancel')">取消</el-button>
        <el-button type="danger" :loading="deleting" @click="confirmDelete">选中素材删除</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed, ref, onUnmounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import pagination from '@/components/pagination.vue'
import { sucaivideomateriallist } from '@/request/new/ylyBatch'
import { selectJuLiangBatchAccountIdAndNameIsNotExsit } from '@/request/new/videoBatchManagement'
import { batchVideoDelete } from '@/request/new/dataConfig'

export default {
  name: 'ylyDeleteVideoTool',
  components: { pagination },
  emits: ['cancel', 'success'],
  setup(props, { emit }) {
    const state = reactive({
      // 左侧账户输入原文
      accountText: '',
      // 右侧素材id输入原文（一行一个）
      materialText: '',
      query: {
        materialName: '',
        page: 1,
        pageSize: 100,
        minDuration: '',
        maxDuration: '',
      },
      list: [],
      total: 0,
      loading: false,
      verifying: false,
      deleting: false,
      directDeleting: false,
      selectedIds: [],
      selectedMap: {},
      // 是否已点过查询（输入账号时不自动查，只有点击查询按钮才查）
      hasSearched: false,
      // 账户校验结果（含名称，和 insertView2 的 resData 一致）
      accountCheckData: [],
    })

    // 账户id：一行一个，排除前后空格，转成数组（去空、去重）
    const accountList = computed(() => {
      const arr = String(state.accountText || '')
        .split(/\r?\n/)
        .map((s) => s.trim())
        .filter((s) => s !== '')
      return [...new Set(arr)]
    })

    // 素材id：一行一个，排除前后空格，转成数组（去空、去重）
    const materialIdList = computed(() => {
      const arr = String(state.materialText || '')
        .split(/\r?\n/)
        .map((s) => s.trim())
        .filter((s) => s !== '')
      return [...new Set(arr)]
    })

    // 查询素材的账户id默认是第一个账户
    const queryAdvertiserId = computed(() => accountList.value[0] || '')

    const getItemId = (item) => item.material_id ?? item.id ?? item.materialId ?? item.video_id

    const normalizeItem = (item) => {
      let imageMode = item.image_mode || null
      if (!imageMode && item.format === 'MP4') {
        imageMode = item.width > item.height ? 'CREATIVE_IMAGE_MODE_VIDEO' : 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'
      }
      if (!imageMode && item.width && item.height) {
        imageMode = item.width > item.height ? 'CREATIVE_IMAGE_MODE_VIDEO' : 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'
      }
      return {
        materialId: item.material_id,
        materialName: item.material_name || item.filename || item.file_name,
        posterUrl: item.poster_url,
        url: item.url,
        videoId: item.id || item.video_id,
        materialType: item.format || 'MP4',
        duration: item.duration,
        imageMode,
      }
    }

    const fetchList = () => {
      if (accountList.value.length === 0) {
        ElMessage.error('请先输入账户id')
        return false
      }
      // if (!String(state.query.materialName || '').trim()) {
      //   ElMessage.error('请输入素材名称')
      //   return false
      // }
      state.loading = true
      const datas = {
        advertiserId: queryAdvertiserId.value,
        page: state.query.page,
        pageSize: state.query.pageSize,
        materialIds: [...materialIdList.value],
      }
      sucaivideomateriallist(datas)
        .then((res) => {
          if (res.code == 200) {
            const d = res.data || {}
            state.list = d.videos || []
            state.total = (d.pageInfo && d.pageInfo.totalNumber) || 0
          } else {
            ElMessage.error(res.msg)
          }
        })
        .catch(() => { })
        .finally(() => {
          state.loading = false
        })
    }

    const searchClick = async () => {
      if (accountList.value.length === 0) {
        ElMessage.error('请先输入账户id')
        return
      }
      // if (!String(state.query.materialName || '').trim()) {
      //   ElMessage.error('请输入素材名称')
      //   return
      // }
      // 先校验账户id是否存在（和 insertView2 的 selectJuLiangBatchAccountIdAndNameIsNotExsit 一致）
      state.verifying = true
      try {
        const checkRes = await selectJuLiangBatchAccountIdAndNameIsNotExsit([...accountList.value])
        if (checkRes.code != 200) {
          ElMessage.error(checkRes.msg || '账户id校验失败')
          return
        }
        state.accountCheckData = checkRes.data || []
      } catch (e) {
        // https.js 已全局提示
        return
      } finally {
        state.verifying = false
      }
      state.query.page = 1
      state.hasSearched = true
      fetchList()
    }

    const handleCurrentChange = (e) => {
      if (!state.hasSearched) return
      state.query.page = e
      fetchList()
    }

    const handleSizeChange = (e) => {
      if (!state.hasSearched) return
      state.query.pageSize = e
      state.query.page = 1
      fetchList()
    }

    // 素材名称 + 时长均为前端过滤：新接口 sucaivideomateriallist 只支持 advertiserId/page/pageSize
    const filteredList = computed(() => {
      let result = state.list
      const nameKeyword = String(state.query.materialName || '').trim().toLowerCase()
      if (nameKeyword) {
        result = result.filter((item) => {
          const name = String(item.material_name || item.filename || item.file_name || item.materialName || item.name || '').toLowerCase()
          return name.includes(nameKeyword)
        })
      }
      const min =
        state.query.minDuration === '' ||
          state.query.minDuration === null ||
          state.query.minDuration === undefined
          ? null
          : Number(state.query.minDuration)
      const max =
        state.query.maxDuration === '' ||
          state.query.maxDuration === null ||
          state.query.maxDuration === undefined
          ? null
          : Number(state.query.maxDuration)
      if ((min === null || Number.isNaN(min)) && (max === null || Number.isNaN(max))) {
        return result
      }
      return result.filter((item) => {
        const d = Number(item.duration)
        if (Number.isNaN(d)) return false
        if (min !== null && !Number.isNaN(min) && d < min) return false
        if (max !== null && !Number.isNaN(max) && d > max) return false
        return true
      })
    })

    const isAllSelected = computed(() => {
      if (filteredList.value.length === 0) return false
      return filteredList.value.every((item) => state.selectedIds.includes(getItemId(item)))
    })

    const selectAll = () => {
      if (isAllSelected.value) {
        const pageIds = filteredList.value.map((item) => getItemId(item))
        state.selectedIds = state.selectedIds.filter((id) => !pageIds.includes(id))
        pageIds.forEach((id) => {
          delete state.selectedMap[id]
        })
      } else {
        filteredList.value.forEach((item) => {
          const id = getItemId(item)
          if (!state.selectedIds.includes(id)) {
            state.selectedIds.push(id)
          }
          state.selectedMap[id] = normalizeItem(item)
        })
      }
    }

    const toggleSelect = (item) => {
      const id = getItemId(item)
      const index = state.selectedIds.indexOf(id)
      if (index > -1) {
        state.selectedIds.splice(index, 1)
        delete state.selectedMap[id]
      } else {
        state.selectedIds.push(id)
        state.selectedMap[id] = normalizeItem(item)
      }
    }

    // 取消选中素材：清空所有已选（含跨页缓存）
    const clearSelected = () => {
      state.selectedIds = []
      state.selectedMap = {}
    }

    // 确定删除：aids = 左侧解析数组，videoIds = 选中素材的 material_id
    const confirmDelete = async () => {
      if (accountList.value.length === 0) {
        return ElMessage.error('账户id不能为空')
      }
      // if (!String(state.query.materialName || '').trim()) {
      //   return ElMessage.error('请输入素材名称')
      // }
      if (state.selectedIds.length === 0) {
        return ElMessage.warning('请先勾选要删除的素材')
      }
      // 把当前页最新数据刷进跨页缓存
      state.list.forEach((item) => {
        const id = getItemId(item)
        if (state.selectedIds.includes(id)) {
          state.selectedMap[id] = normalizeItem(item)
        }
      })
      const videoIds = state.selectedIds.map((id) => {
        const cached = state.selectedMap[id]
        return (cached && cached.materialId) || id
      })

      try {
        await ElMessageBox.confirm(
          `将为 ${accountList.value.length} 个账户删除 ${videoIds.length} 个素材，是否继续？`,
          '选中素材删除',
          { type: 'warning', confirmButtonText: '选中素材删除', cancelButtonText: '取消' },
        )
      } catch (e) {
        return
      }

      state.deleting = true
      const datas = {
        aids: [...accountList.value],
        videoIds,
      }
      try {
        const res = await batchVideoDelete(datas)
        // dataConfig 走 httpNew，成功时 resolve 的是 axios response（res.data.code）
        const code = res && res.data && res.data.code
        if (code == 200) {
          ElMessage.success('删除成功')
          emit('success')
        }
      } catch (e) {
        // httpNew 已全局提示
      } finally {
        state.deleting = false
      }
    }

    // 通过素材id删除：请求完成后的冷却倒计时（秒），大于 0 时按钮不可用
    const directCooldown = ref(0)
    let directCooldownTimer = null

    const startDirectCooldown = (seconds = 20) => {
      if (directCooldownTimer) {
        clearInterval(directCooldownTimer)
        directCooldownTimer = null
      }
      directCooldown.value = seconds
      directCooldownTimer = setInterval(() => {
        directCooldown.value -= 1
        if (directCooldown.value <= 0) {
          clearInterval(directCooldownTimer)
          directCooldownTimer = null
          directCooldown.value = 0
        }
      }, 1000)
    }

    onUnmounted(() => {
      if (directCooldownTimer) {
        clearInterval(directCooldownTimer)
        directCooldownTimer = null
      }
    })

    // 直接删除：账户ID和素材ID为必填，先校验账户再调用 batchVideoDelete
    const directDelete = async () => {
      if (directCooldown.value > 0) {
        return ElMessage.warning(`操作过于频繁，请 ${directCooldown.value} 秒后再试`)
      }
      if (accountList.value.length === 0) {
        return ElMessage.error('账户id不能为空')
      }
      if (materialIdList.value.length === 0) {
        return ElMessage.error('素材id不能为空')
      }
      try {
        await ElMessageBox.confirm(
          `将为 ${accountList.value.length} 个账户直接删除 ${materialIdList.value.length} 个素材，是否继续？`,
          '通过素材id删除',
          { type: 'warning', confirmButtonText: '通过素材id删除', cancelButtonText: '取消' },
        )
      } catch (e) {
        return
      }
      state.directDeleting = true
      try {
        const checkRes = await selectJuLiangBatchAccountIdAndNameIsNotExsit([...accountList.value])
        if (checkRes.code != 200) {
          ElMessage.error((checkRes && checkRes.msg) || '账户id校验失败')
          return
        }
        state.accountCheckData = checkRes.data || []
        const datas = {
          aids: [...accountList.value],
          videoIds: [...materialIdList.value],
        }
        const res = await batchVideoDelete(datas)
        const code = res && res.data && res.data.code
        if (code == 200) {
          ElMessage.success('删除成功')
          // 通过素材id删除完成后不关闭弹窗，仅提示成功
        }
      } catch (e) {
        // https.js / httpNew 已全局提示
      } finally {
        state.directDeleting = false
        // 请求完成后 20 秒内按钮不可用，并提示
        startDirectCooldown(20)
        ElMessage.warning('操作已完成，为避免重复提交，20 秒内不可再次删除')
      }
    }

    return {
      ...toRefs(state),
      accountList,
      materialIdList,
      queryAdvertiserId,
      getItemId,
      filteredList,
      isAllSelected,
      directCooldown,
      searchClick,
      handleCurrentChange,
      handleSizeChange,
      selectAll,
      toggleSelect,
      clearSelected,
      confirmDelete,
      directDelete,
    }
  },
}
</script>

<style lang="scss" scoped>
.delete-video-tool {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tool-main {
  display: flex;
  gap: 16px;
}

.tool-left {
  width: 280px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.tool-left-double {
  width: 560px;
  flex-direction: row;
  gap: 12px;

  .left-col {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }
}

.left-title {
  font-size: 14px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 8px;
}

.left-count {
  margin-left: 6px;
  font-size: 12px;
  font-weight: 400;
  color: #409eff;
}

.left-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;

  b {
    color: #303133;
  }
}

.empty-tip {
  color: #f56c6c;
}

.tool-right {
  flex: 1;
  min-width: 0;
}

.right-empty-tip {
  padding: 24px 0;
  text-align: center;
  font-size: 13px;
  color: #909399;
}

.sucai-search-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.sucai-label {
  flex-shrink: 0;
  font-size: 14px;
  color: #606266;
}

.sucai-range-sep {
  color: #909399;
  margin: 0 -6px;
}

.sucai-duration-input {
  width: 76px;

  :deep(.el-input__inner) {
    height: 28px;
    line-height: 28px;
    padding: 0 6px;
    font-size: 12px;
    text-align: center;
  }
}

.sucai-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
  max-height: 420px;
  overflow-y: auto;
}

.sucai-grid-item {
  border: 1px solid #ebeef5;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.2s;

  &.active {
    border-color: #409eff;
    box-shadow: 0 0 0 1px #409eff;
  }
}

.sucai-cover {
  position: relative;
  height: 120px;
  background: #f5f7fa;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .sucai-mask {
    position: absolute;
    inset: 0;
    background: rgba(64, 158, 255, 0.25);
    border: 2px solid #409eff;
    box-sizing: border-box;
  }

  .sucai-check {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 22px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    background: #409eff;
    color: #fff;
    border-radius: 50%;
    font-size: 13px;
    font-weight: 700;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
    z-index: 1;
  }
}

.sucai-selected-count {
  font-size: 13px;
  color: #409eff;
}

.sucai-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 6px 8px;
  min-width: 0;
}

.sucai-name {
  width: 100%;
  min-width: 0;
  font-size: 12px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sucai-duration {
  flex-shrink: 0;
  padding: 0 6px;
  font-size: 11px;
  line-height: 18px;
  color: #409eff;
  background: #ecf5ff;
  border-radius: 4px;
  white-space: nowrap;
}

.sucai-pagination {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.tool-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 4px;
}

.footer-right {
  display: flex;
  gap: 12px;
}
</style>
